import React, { ChangeEvent, useEffect, useState } from 'react';
import "./DCDatePicker.scss";
import { ReactSVG } from 'react-svg';

// Component properties interface
interface DCDatePickerProps {
    value: string;
    placeholder: string;
    required?: boolean;
    onBlur: (event: ChangeEvent<HTMLInputElement>) => void;
    onInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    disabled?: boolean; // Optional disabled prop
}

export const DCDatePicker = ({
    value,
    placeholder,
    required = true,
    onBlur,
    onInputChange,
    onKeyUp,
    disabled = false // Default to false if not provided
}: DCDatePickerProps) => {

    const [inputValue, setInputValue] = useState<string>('');
    const [isValid, setIsValid] = useState<boolean>(true);
    const [touch, setTouch] = useState<boolean>(false);

    const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!disabled) { // Only handle key up if not disabled
            setTouch(true);
            if (onKeyUp) {
                onKeyUp(e);
            }
        }
    }
    useEffect(() => {
        if (value) {

            setInputValue(value);
            setIsValid(true);
        }
    }, [value]);
    
    useEffect(() => {
        // Skip validation logic if disabled
        if (disabled) return;

        if (required && touch && inputValue.length === 0) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }

        // Check if number of years have more than 4 digits
        if (required && touch) {
            let date = new Date(value);
            const yearLength = date.getFullYear().toString().length;
            if (yearLength > 4 || inputValue.length === 0) {
                setIsValid(false);
            } else {
                setIsValid(true);
            }
        }

    }, [inputValue, required, touch, value, disabled]); // Include disabled in dependencies

    return (
        <div>
            <div className={isValid && !disabled ? "DCDatePickerInput DCDatePickerInputValid" : "DCDatePickerInput"}>
                <span>{required ? placeholder : `${placeholder} (optional)`}</span>
                <input type="date"
                    data-testid="datePicker"
                    value={value}
                    onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (!disabled) { // Only handle input if not disabled
                            if (!inputValue) {
                                setIsValid(false);
                            }
                            setInputValue(e.target.value);
                            setTouch(true);
                            onInputChange(e);
                        }
                    }}
                    onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (!disabled) { // Only handle blur if not disabled
                            required ? setIsValid(e.target.value.length > 0) : setIsValid(true);
                            setTouch(true);
                            onBlur(e);
                        }
                    }}
                    onKeyUp={handleKeyUp}
                    disabled={disabled}
                >
                </input>
                {/* Hide error icon and message when disabled */}
                {!disabled && !isValid ? <div id="dcDatePickerErrorIcon"><ReactSVG src="https://cdn.jsdelivr.net/npm/@alaskaairux/icons@latest/dist/icons/alert/error.svg" /></div> : null}
            </div>
            {!disabled && !isValid ? <div id="dcDatePickerErrorMessage"><span>Please fill out this field.</span></div> : null}
        </div>
    );
};
